module.exports = __webpack_public_path__ + "img/fluid-filler-yellow.82c07d91.svg";